module.exports = __webpack_public_path__ + "965a9bbc3bb0b77d4e81f3dd1fc26667.MP3";